/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import keyboard from 'keycode-ui';
import PubSub from 'pubsub-js';

/*---------------------------------------------------------*\
 * Constants
\*---------------------------------------------------------*/
const labelMap = (label) => {
  return {
    label
  };
};
const deps = {};
/*---------------------------------------------------------*\
 * ClosingsDelaysLanding
\*---------------------------------------------------------*/
class ClosingsDelaysLandingController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($rootScope, regionService, navigationService, closingsAndDelaysService,
              localService, storageKeys, $timeout, $scope, $state, topics) {
    this.name = 'closingsDelaysLanding';

    this.regionService = regionService;
    this.navigationService = navigationService;
    this.closingsAndDelaysService = closingsAndDelaysService;
    this.$timeout = $timeout;
    this.currentRegion = localService.get(storageKeys.selectedRegion);

    this.localService = localService;
    this.storageKeys = storageKeys;

    this.headerConfig = {
      hideNewsTicker: true
    };

    deps.navigationService = navigationService;
    deps.topics = topics;
    deps.$state = $state;
    deps.$scope = $scope;
    deps.$rootScope = $rootScope;
    this.alphaData = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(labelMap);
    this.communities = undefined;
    this.closingsAndDelays = undefined;

    this.page = 0;
    this.pageSize = 6;

    this.alphaList_itemClickHandler = this.alphaList_itemClickHandler.bind(this);
    this.communityList_itemClickHandler = this.communityList_itemClickHandler.bind(this);
    this.communityList_prevComponentHandler = this.communityList_prevComponentHandler.bind(this);
    this.communityList_nextComponentHandler = this.communityList_nextComponentHandler.bind(this);
    this.alphaList_nextComponentHandler = this.alphaList_nextComponentHandler.bind(this);

    const token1 = PubSub.subscribe(deps.topics.headerMain.selectSection, (msg, item) => {
      this.onSectionSelect(item);
    });

    const token2 = PubSub.subscribe(deps.topics.state.reactivate, () => {
      if (deps.$rootScope.previousActiveElement) {
        $timeout(() => {
          this.navigationService.focusEl('#alphaList');
          delete deps.$rootScope.previousActiveElement;
        });
      }
    });

    const token3 = PubSub.subscribe(deps.topics.state.inactivate, () => {
      // clear when leaving to a modal like T&W weather or forcast video. When coming back start over
      this.communities = undefined;
      this.closingsAndDelays = undefined;
    });

    deps.$scope.$on('$destroy', () => {
      PubSub.unsubscribe(token1);
      PubSub.unsubscribe(token2);
      PubSub.unsubscribe(token3);
    });
  }

  //-----------------------------------
  // Lifecycle
  //-----------------------------------
  $postLink() {
    this.regionService.getCities(this.region).then((data) => {
      this.townships = data.data.DataSet['diffgr:diffgram'].NewDataSet.cities.map((city) => {
        return city.CITY;
      });
      this.navigationService.focusElAsync('#alphaList');
    });
  }

  //-----------------------------------
  // Properties
  //-----------------------------------
  set closingsAndDelays(value) {
    this._closingsAndDelays = value;

    this.updatePage();
  }

  get closingsAndDelays() {
    return this._closingsAndDelays;
  }

  set page(value) {
    this._page = value;

    this.updatePage();
  }

  get page() {
    return this._page;
  }

  get closingsAndDelaysPage() {
    return this._closingsAndDelaysPage;
  }

  get totalPages() {
    return this.closingsAndDelays ? Math.ceil(this.closingsAndDelays.length / this.pageSize) : 0;
  }

  get hasNext() {
    return this.page + 1 < this.totalPages;
  }

  get hasPrev() {
    return this.page > 0;
  }

  get pageEndIndex() {
    return Math.min((this.page * this.pageSize) + this.pageSize, this.closingsAndDelays.length);
  }

  get region() {
    const _region = this.localService.get(this.storageKeys.selectedRegion);

    return _region ? _region.abbr : 'LI';
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  updatePage() {
    this._closingsAndDelaysPage = this._closingsAndDelays ?
      this._closingsAndDelays.slice(this.page * this.pageSize, (this.page * this.pageSize) + this.pageSize).concat() :
      [];

    for (let i = this._closingsAndDelaysPage.length; i < 6; i++) {
      this._closingsAndDelaysPage.push({});
    }
  }

  //-----------------------------------
  // Events
  //-----------------------------------
  alphaList_itemClickHandler(event) {
    this.alphaSelectedIndex = event.$index;

    // clear old closings
    this.closingsAndDelays = undefined;

    this.communities = this.townships.filter((town) => {
      return town ? town.charAt(0) === event.item.label : false;
    }).map(labelMap);

    if (this.communities.length) {
      this.navigationService.focusElAsync('#communityList');
    }
  }

  listPrevComponentHandler(index, up) {
    if (up) {
      deps.navigationService.focusEl('navbar');
    }
  }

  communityList_itemClickHandler(event) {
    this.page = 0;

    this.communityListIndex = event.$index;

    this.closingsAndDelaysService.getClosings(this.region, event.item.label).then((data) => {
      this.closingsAndDelays = data.data.DataSet.NewDataSet.closings;

      this.navigationService.focusElAsync('.nextTarget');
    });
  }

  alphaList_nextComponentHandler(nextIndex, down) {
    if (down) {
      return;
    }
    this.alphaSelectedIndex = nextIndex;

    if (this.communities && this.communities.length) {
      this.navigationService.focusElAsync('#communityList', this.communityListIndex);
    }
  }

  communityList_prevComponentHandler(nextIndex, isUp) {
    this.communityListIndex = nextIndex;

    if (isUp) {
      deps.navigationService.focusEl('navbar');
    } else {
      deps.navigationService.focusEl('#alphaList', this.alphaSelectedIndex);
    }
  }

  communityList_nextComponentHandler(nextIndex, down) {
    this.communityListIndex = nextIndex;

    // If the user has pressed right from communities
    if (!down && this.communities && this.communities.length) {
      if (document.getElementById('prev')) {
        this.navigationService.focusElAsync('#prev');
      } else if (document.getElementById('next')) {
        this.navigationService.focusElAsync('#next');
      } else if (document.getElementById('main')) {
        this.navigationService.focusElAsync('#main');
      }
    }
  }

  prevSelectHandler() {
    this.page -= 1;

    if (this.page === 0) {
      this.navigationService.focusElAsync('.nextTarget');
    }
  }

  nextSelectHandler() {
    this.page += 1;

    if (this.page + 1 === this.totalPages) {
      this.navigationService.focusElAsync('.prevTarget');
    }
  }

  main_onSelect() {
    this.page = 0;

    if (this.page === 0) {
      this.navigationService.focusElAsync('.nextTarget');
    }
  }

  prevNextMainLeftHandler(event, which) {
    if (keyboard.isLeft(event) &&
      ((which === 'main' && !this.hasNext && !this.hasPrev) || (which === 'prev') ||
      (which === 'next' && !this.hasPrev))) {
      this.navigationService.focusElAsync('#communityList', this.communityListIndex);
    } if (keyboard.isUp(event)) {
      this.navigationService.focusElAsync('navbar', 'last');
    }
  }

  onSectionSelect(item) {
    if (item && item.state && item.state.name) {
      if (item.state.params) {
        deps.$state.go(item.state.name, item.state.params);
      } else {
        deps.$state.go(item.state.name);
      }
    }
  }
}

ClosingsDelaysLandingController.$inject = [
  '$rootScope',
  'regionService',
  'navigationService',
  'closingsAndDelaysService',
  'localService',
  'storageKeys',
  '$timeout',
  '$scope',
  '$state',
  'topics'
];

export default ClosingsDelaysLandingController;



/** WEBPACK FOOTER **
 ** ./client/app/components/closingsDelaysLanding/closingsDelaysLanding.controller.js
 **/